import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const PriceListFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default PriceListFilter;
